import React from "react";

import Favorites from "./favorites-mapping";

const FavoritesRoute = ({ router }) => {
  return <Favorites router={router} />;
};

export default FavoritesRoute;
